import {UserStore} from "../stores/UserStore";

export default class User {

    constructor() {
        this.store = new UserStore();
        this.user = this.store.data || null;
    }

    check() {
        return this.user && Boolean(this.user?.id > 0);
    }

    guest() {
        return !this.check();
    }

    id() {
        return this.user ? this.user.id : null;
    }

    clear() {
        this.store.setUser(null);
    }

    data() {
        return this.user;
    }

    settings() {
        let data = this.data();
        return data ? data.settings : {};
    }

    update(user) {
        this.store.setUser(user);
    }

    isCommentsIgnoredForUser(user_id) {
        return this.user.blocked.comments && this.user.blocked.comments.includes(user_id);
    }

    isPostsIgnoredForUser(user_id) {
        return this.user.blocked.posts && this.user.blocked.posts.includes(user_id);
    }
}